/** Runtime helpers for structured evidence returned by document sources. */

import type { StructuredEvidenceDocumentResponse } from "../../../../api/clinicalTrialsApiTypes";

/** Check an unknown source payload before rendering it as structured evidence. */
export function isStructuredEvidenceDocumentResponse(
  value: unknown,
): value is StructuredEvidenceDocumentResponse {
  if (typeof value !== "object" || value === null) return false;
  const candidate = value as Record<string, unknown>;
  return (
    typeof candidate.document_type === "string" &&
    typeof candidate.document_name === "string" &&
    typeof candidate.sections === "object" &&
    candidate.sections !== null &&
    !Array.isArray(candidate.sections)
  );
}

/** Convert escaped API newline markers into displayable line breaks. */
export function normalizeStructuredEvidenceText(value: string): string {
  return value
    .replace(/\r\n?/g, "\n")
    .replace(/\\r\\n/g, "\n")
    .replace(/\\n/g, "\n")
    .replace(/\/n/g, "\n");
}

/** Convert a section value into text suitable for a read-only Oasis field. */
export function formatStructuredEvidenceValue(value: unknown): string {
  if (value == null) return "";
  if (typeof value === "string") return normalizeStructuredEvidenceText(value);
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}
